// extracted by mini-css-extract-plugin
module.exports = {"result":"_60b13338","icon":"_9b1f189a","title":"_3550131","description":"_f4e3a317"};